// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","395":"component---src-templates-blog-template-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"4a8eabdbae0d03b98901","245":"0f0af2d4ddc89467440a","395":"9ec505e8bcee3a401c38","453":"faee3b1968fe68eb00f8"}[chunkId] + ".js";
};